import { apiClient } from '@/core/api/client';
import type {
  GetSettingsResponse,
  UpdateSettingsResponse,
  UpdateSettingsRequest
} from '../types/settings.types';

/**
 * Settings API Client
 * Handles user settings API requests
 */
export const settingsApi = {
  /**
   * Fetch user settings
   * GET /api/users/settings
   */
  fetchSettings: async (): Promise<GetSettingsResponse> => {
    return apiClient.get<GetSettingsResponse>('/api/users/settings');
  },

  /**
   * Update user settings
   * PUT /api/users/settings
   */
  updateSettings: async (settings: UpdateSettingsRequest): Promise<UpdateSettingsResponse> => {
    return apiClient.put<UpdateSettingsResponse>('/api/users/settings', settings);
  }
};
